import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useMemo } from 'react';
import { Menu } from '@headlessui/react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { useFloating, offset, flip, shift, autoUpdate, FloatingPortal } from '@floating-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Dropdown(_ref) {
  var title = _ref.title,
      triggerElement = _ref.triggerElement,
      items = _ref.items,
      disabled = _ref.disabled,
      wrapperStyle = _ref.wrapperStyle,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement;

  var _useFloating = useFloating({
    placement: placement,
    middleware: [offset(8), flip(), shift()],
    whileElementsMounted: autoUpdate
  }),
      refs = _useFloating.refs,
      floatingStyles = _useFloating.floatingStyles;

  var mainItems = useMemo(function () {
    return items === null || items === void 0 ? void 0 : items.filter(function (v) {
      return !v.isFooterItem;
    });
  }, [items]);
  var footerItems = useMemo(function () {
    return items === null || items === void 0 ? void 0 : items.filter(function (v) {
      return v.isFooterItem;
    });
  }, [items]);
  return /*#__PURE__*/_jsx(Wrapper, {
    twStyle: wrapperStyle,
    children: /*#__PURE__*/_jsxs(Menu, {
      children: [/*#__PURE__*/_jsx(Menu.Button, {
        as: "div",
        ref: refs.setReference,
        disabled: disabled,
        children: triggerElement
      }), /*#__PURE__*/_jsx(FloatingPortal, {
        children: /*#__PURE__*/_jsxs(Menu.Items, {
          as: "section",
          className: "rounded-lg border border-neutral-90 bg-neutral-10 w-fit p-2 shadow-[0px 4px 16px 0px rgba(0, 0, 26, 0.25)] absolute -top-10",
          ref: refs.setFloating,
          style: _objectSpread({
            boxShadow: '0px 4px 16px 0px rgba(0, 0, 26, 0.25)',
            zIndex: 9999
          }, floatingStyles),
          children: [!!title && /*#__PURE__*/_jsx(_StyledSpan, {
            children: title
          }), mainItems === null || mainItems === void 0 ? void 0 : mainItems.map(function (item, index) {
            return /*#__PURE__*/_jsx(MenuItem, _objectSpread({}, item), index);
          }), !!(footerItems !== null && footerItems !== void 0 && footerItems.length) && /*#__PURE__*/_jsx(_StyledHr, {}), footerItems === null || footerItems === void 0 ? void 0 : footerItems.map(function (item, index) {
            return /*#__PURE__*/_jsx(MenuItem, _objectSpread({}, item), index);
          })]
        })
      })]
    })
  });
}
export default Dropdown;

function MenuItem(_ref2) {
  var isCriticalAction = _ref2.isCriticalAction,
      Icon = _ref2.Icon,
      label = _ref2.label,
      isSelected = _ref2.isSelected,
      _onClick = _ref2.onClick,
      disabled = _ref2.disabled,
      href = _ref2.href;
  var iconClasses = '!h-6 !w-6 min-w-[24px] min-h-[24px]';
  return /*#__PURE__*/_jsx(Menu.Item, {
    disabled: disabled,
    children: function children(_ref3) {
      var active = _ref3.active,
          close = _ref3.close;
      return /*#__PURE__*/_jsxs(MenuItemContent, {
        href: href || '#!',
        onClick: function onClick(e) {
          if (!href || disabled) {
            e.preventDefault();
          }

          if (!disabled) {
            _onClick && _onClick();
            close();
          }
        },
        active: active,
        isCriticalAction: isCriticalAction,
        isSelected: isSelected,
        disabled: disabled,
        children: [/*#__PURE__*/_jsxs(IconAndLabelWrapper, {
          children: [Icon ? /*#__PURE__*/_jsx(Icon, {
            className: iconClasses
          }) : null, /*#__PURE__*/_jsx(LabelText, {
            isSelected: isSelected,
            hasIcon: !!Icon,
            children: label
          })]
        }), isSelected && /*#__PURE__*/_jsx(CheckCircleIcon, {
          className: "".concat(iconClasses, " text-purple-700")
        })]
      });
    }
  });
}

var MenuItemContent = /*#__PURE__*/_styled.a.withConfig({
  displayName: "dropdown__MenuItemContent",
  componentId: "sc-1bx7f88-0"
})(["", " ", " ", " ", " ", ""], {
  "display": "flex",
  "height": "3rem",
  "width": "288px",
  "alignItems": "center",
  "justifyContent": "space-between",
  "gap": "0.5rem",
  "borderRadius": "0.5rem",
  "paddingLeft": "1.25rem",
  "paddingRight": "1.25rem",
  "fontSize": "1rem !important",
  "lineHeight": "1.5rem !important",
  "fontWeight": "500"
}, function (_ref4) {
  var active = _ref4.active,
      isCriticalAction = _ref4.isCriticalAction;
  return active && !isCriticalAction ? {
    "backgroundColor": "rgb(0 0 26 / 0.2)"
  } : active && isCriticalAction ? {
    "backgroundColor": "rgb(145 0 24 / 0.2)"
  } : {};
}, function (_ref5) {
  var isCriticalAction = _ref5.isCriticalAction;
  return isCriticalAction ? {
    "--tw-text-opacity": "1",
    "color": "rgb(145 0 24 / var(--tw-text-opacity))",
    ":hover": {
      "backgroundColor": "rgb(145 0 24 / 0.1)"
    },
    ":active": {
      "backgroundColor": "rgb(145 0 24 / 0.2)"
    }
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))",
    ":hover": {
      "backgroundColor": "rgb(0 0 26 / 0.1)"
    },
    ":active": {
      "backgroundColor": "rgb(0 0 26 / 0.2)"
    }
  };
}, function (_ref6) {
  var isSelected = _ref6.isSelected;
  return isSelected ? {
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))"
  } : {};
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? {
    "cursor": "not-allowed",
    "--tw-text-opacity": "1",
    "color": "rgb(117 117 131 / var(--tw-text-opacity))"
  } : {};
});

var IconAndLabelWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "dropdown__IconAndLabelWrapper",
  componentId: "sc-1bx7f88-1"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem"
});

var LabelText = /*#__PURE__*/_styled.span.withConfig({
  displayName: "dropdown__LabelText",
  componentId: "sc-1bx7f88-2"
})(["", " ", ""], {
  "display": "inline-block",
  "overflow": "hidden",
  "textOverflow": "ellipsis",
  "whiteSpace": "nowrap"
}, function (_ref8) {
  var isSelected = _ref8.isSelected,
      hasIcon = _ref8.hasIcon;
  return !isSelected && hasIcon || isSelected && !hasIcon ? {
    "maxWidth": "225px"
  } : isSelected && hasIcon ? {
    "maxWidth": "180px"
  } : {
    "maxWidth": "270px"
  };
});

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "dropdown__Wrapper",
  componentId: "sc-1bx7f88-3"
})(["", ";", ""], {
  "zIndex": "10"
}, function (_ref9) {
  var twStyle = _ref9.twStyle;
  return twStyle;
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "dropdown___StyledSpan",
  componentId: "sc-1bx7f88-4"
})({
  "marginBottom": "0.5rem",
  "display": "block",
  "paddingLeft": "1.25rem",
  "paddingRight": "1.25rem",
  "paddingTop": "0.75rem",
  "fontSize": "1rem !important",
  "lineHeight": "1.5rem !important",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});

var _StyledHr = /*#__PURE__*/_styled("hr").withConfig({
  displayName: "dropdown___StyledHr",
  componentId: "sc-1bx7f88-5"
})({
  "marginTop": "0.5rem",
  "marginBottom": "0.5rem"
});